import get from 'lodash/get';
import { take, takeEvery, put, select } from 'redux-saga/effects';
import { consts as membersList } from './membersList';
import { consts as communityMembers } from './communityMembers';
import { membersListLengthSelector } from './selectors/selectors';

function* getMembersListWorker(action) {
  // Dispatch clear action
  if (action.type === communityMembers.CLEAR_MEMBERS) {
    yield put({
      type: membersList.CLEAR,
    });
    return;
  }

  const MEMBERS_PER_PAGE = 20;
  const state = yield select();
  const communityId = +get(action.payload, 'communityId');

  const limit = MEMBERS_PER_PAGE;
  let offset = 0;
  let responseAction = membersList.LOAD_MEMBERS;

  if (action.type === communityMembers.GET_OLDER_MEMBERS) {
    offset = membersListLengthSelector(state);
    responseAction = membersList.LOAD_OLDER_MEMBERS;
  }

  // Dispatch request
  yield put({
    type: communityMembers.SEND,
    payload: { communityId, limit, offset },
  });

  // Process response
  const response = yield take(communityMembers.SUCCEED);

  const membersListRes = get(response, 'payload', []);

  // Dispatch response
  yield put({
    type: responseAction,
    payload: [...membersListRes],
  });
}

export function* getMembersListSaga() {
  yield takeEvery(
    [
      communityMembers.GET_MEMBERS,
      communityMembers.GET_OLDER_MEMBERS,
      communityMembers.CLEAR_MEMBERS,
    ],
    getMembersListWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/communities/membersListSaga.js